/**
 * @ngdoc Controller
 * @name ActivityFeedController
 */
(function () {
    'use strict';

    angular.module('vrm.core')
        .controller('AdminDealersController', AdminDealersController)
        .controller('AdminDealersFormController', AdminDealersFormController)
        .controller('AdminDealersDetailController', AdminDealersDetailController);

    /**
     * @constructor
     * @ngInject
     */
    function AdminDealersController($log, $scope, AdminTableService, VrmModalService, vrmNotificationsService, vrmNotificationType, ApiService, locale) {
        $log.info('AdminDealersController');
        $scope.table = new AdminTableService("dealers");

        $scope.remove = function(id)
        {
            VrmModalService.openConfirmModal($scope, 'delete', function(confirmed) {
                if (confirmed && id)
                {
                    ApiService.admin('dealers/' + id, {}, 'DELETE').then(function() {
                        locale.ready('admin').then(function () {
                            vrmNotificationsService.add( {type: vrmNotificationType.SUCCESS, message: locale.getString('admin.dealer_deleted') });
                            $scope.table.params.reload();
                        });
                    });
                }
            });
        }
    }

    /**
     * @constructor
     * @ngInject
     */
    function AdminDealersFormController($log, $scope, $stateParams, ApiService, $state, vrmNotificationsService, locale, vrmNotificationType)
    {
        $log.info('AdminDealersFormController');

        var browseState      = 'base.admin.dealers';
        $scope.whitelabels  = [{id: null, name: '-'}];
        $scope.dealer       = {whitelabel: $scope.whitelabels[0]};
        $scope.editing      = $stateParams.id ? true : false;

        // Get whitelabels
        ApiService.call('/admin/whitelabels', {}, 'GET').then(function(response) {
            $scope.whitelabels = $scope.whitelabels.concat(response.data.records);

            // Retrieve dealer
            if ($stateParams.id)
            {
                ApiService.admin('dealers',{'filter[idDealer]' : $stateParams.id}).then(function(response) {
                    // Check if no record is found, if so return to browse
                    if (response.data.num_records < 1) $state.go(browseState);

                    // Set on scope
                    $scope.dealer = parse(response.data.records[0]);
                });
            }
        });

        function parse(dealer)
        {
            var res = {};
            res.name = dealer.name;
            res.whitelabel = _.find($scope.whitelabels, function(record) {
               return record.id == dealer.idWhiteLabel;
            });
            return res;
        }

        $scope.doSave = function() {
            // Gather data
            var data = {
                name: $scope.dealer.name,
                idWhiteLabel: $scope.dealer.whitelabel.id
            };

            // Save
            ApiService.admin('dealers/' + ($scope.editing ? $stateParams.id : ''), data, $scope.editing ? 'PUT' : 'POST').then(function() {
                locale.ready('admin').then(function () {
                    vrmNotificationsService.add( {type: vrmNotificationType.SUCCESS, message: locale.getString('admin.dealer_saved') });
                    $state.go(browseState);
                });

            });

        }
    }

    /**
     * @constructor
     * @ngInject
     */
    function AdminDealersDetailController($log, $scope, ApiService, $stateParams, vrmUserAccessLevel) {
        $log.info('AdminDealersDetailController');

        $scope.users = [];
        $scope.dealer = {};

        ApiService.admin('users', {'filter[idDealer]': $stateParams.id, count: 1000,'sorting[email]': 'asc'}).then(function (response) {
            $scope.users = response.data.records;
        });

        ApiService.admin('dealers', {'filter[idDealer]': $stateParams.id}).then(function (response) {
            // Check if no record is found, if so return to browse
            if (response.data.num_records < 1) $state.go(base.admin.dealers);

            // Set on scope
            $scope.dealer = response.data.records[0];
        });

        $scope.getAccessLevel = function(accessLevel)
        {
            var res = '';
            _.each(vrmUserAccessLevel, function(val, key) {
                if (val == accessLevel)
                    res = key;
            });
            return res.toLocaleLowerCase().replace('_', ' ');
        }

    }
})();
